/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";

import Search from "../../assets/icons/Search";
import ChevronUp from "../../assets/icons/ChevronUp";
import ChevronDown from "../../assets/icons/ChevronDown";

const Select = ({ label, onChange, hasError, options, value, readOnly }) => {
  const FirstRender = useRef(true);
  const [Options, setOptions] = useState(options);
  const [ShowOptions, setShowOptions] = useState(false);
  const [SearchValue, setSearchValue] = useState("");
  const [SelectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    setOptions(options);
  }, [options]);

  useEffect(() => {
    const isExist = Object.keys(options).find((key) => key === value);
    if (isExist) {
      setSelectedItem({ key: isExist, value: options[isExist] });
    }
  }, [value]);

  useEffect(() => {
    if (FirstRender.current) {
      FirstRender.current = false;
      return;
    }
    const delayInputTimeoutId = setTimeout(() => {
      if (SearchValue === "") {
        setOptions(options);
      } else {
        const newOptions = {};
        Object.keys(options).forEach((op) => {
          if (options[op].toLowerCase().includes(SearchValue)) {
            newOptions[op] = options[op];
          }
        });
        setOptions(newOptions);
      }
    }, 800);
    return () => clearTimeout(delayInputTimeoutId);
  }, [SearchValue]);

  // useEffect(() => {
  //   if (SelectedItem) {
  //     onChange(SelectedItem);
  //   }
  // }, [SelectedItem]);

  return (
    <div className="relative min-w-max h-fit">
      <span
        className={[
          "absolute top-0 left-0 bg-white font-medium text-gray text-xs z-[1] whitespace-nowrap pe-4",
          hasError && "border-b border-b-red-error",
        ].join(" ")}
      >
        <span
          className={[
            "w-3 h-[22px] bg-gray-background absolute -right-0.5 rotate-45 top-0.5",
            hasError && "border-l border-l-red-error",
          ].join(" ")}
        />
        <span
          className={["relative bottom-1", hasError && "text-red-error"].join(
            " "
          )}
        >
          {label}
        </span>
      </span>
      <div
        className={[
          "ps-2 pt-5 pe-9 pb-[10px] bg-gray-background text-gray-dark_text font-medium rounded-lg outline-none w-full realtive h-14 cursor-pointer",
          hasError && "border border-red-error",
        ].join(" ")}
        dir="auto"
        onClick={(e) => {
          e.stopPropagation();
          setShowOptions((prev) => (readOnly ? false : !prev));
        }}
      >
        {SelectedItem?.value || ""}
        <span className="absolute right-3">
          {ShowOptions ? <ChevronUp color="#ACC1CC" /> : <ChevronDown />}
          {ShowOptions && (
            <div
              onClick={(e) => {
                setShowOptions(false);
                e.stopPropagation();
              }}
              className="fixed top-0 right-0 left-0 bottom-0 z-[2] cursor-default"
            />
          )}
        </span>
        {ShowOptions && (
          <div
            onClick={(e) => e.stopPropagation()}
            className="absolute flex flex-col z-50 max-h-64 overflow-auto rounded-[4px] bg-gray-box_back top-11"
          >
            <div className="px-4 py-3 relative">
              <div className="absolute left-6 top-1/2 -translate-y-1/2">
                <Search color="#9593AD" />
              </div>
              <input
                className="ps-8 pe-2 py-2 bg-gray-dark_back rounded-[4px] placeholder:text-gray-dark_text1 text-gray-light_text outline-none border-0"
                type="text"
                value={SearchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="Search ..."
              />
            </div>
            <div className="flex flex-col grow-[1] overflow-auto scrollbar">
              {Object.keys(Options).map((op, i) => (
                <span
                  className="cursor-pointer px-4 py-2 text-gray-background even:bg-gray-box_back odd:bg-gray-box_back2"
                  value={op}
                  key={i}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedItem({ key: op, value: options[op] });
                    onChange({ key: op, value: options[op] });
                    setSearchValue("");
                    setShowOptions(false);
                  }}
                >
                  {Options[op]}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Select;
